import { getAppConfig } from '@services/config';
import { apiHttpService } from '@services/http';
import { CACHE_TAGS } from '@services/http/http';

import { MCubeMapper } from '@mappers/mcube';

import { ImpactSimulationRequestOptions, ImpactSimulationResponse } from '@app-types/api/mcube';
import { GalliumData, SimulationDataApi } from '@app-types/gallium';
import { ImpactsSimulation } from '@app-types/simulator/simulator';
import { UserType } from '@app-types/user';

const appConfig = getAppConfig();

export class MCubeRepository {
    private readonly url: string;

    public constructor(url: string) {
        this.url = url;
    }

    public async getImpactSimulationByPerson(user: UserType, gencodes: string[]): Promise<ImpactsSimulation | null> {
        const headers = this.getHeaders(user);
        const data: ImpactSimulationRequestOptions = {
            idOffreCible: gencodes.filter((g) => g),
            parcours: 'ACTIVATION',
        };

        const response = await apiHttpService.post<ImpactSimulationResponse>(
            `${this.url}/personnes/${user?.sub}/simulation-impacts-parc`,
            data,
            { headers },
        );

        return MCubeMapper.mapToImpactsSimulation(response);
    }

    public async getSimulationImpactsOffres(user: UserType, contractId: string): Promise<GalliumData | undefined> {
        try {
            const data = await apiHttpService.get<SimulationDataApi>(
                `${this.url}/contrats/${contractId}/simulation-impacts-offres?typeParcours=RENOUVELLEMENT`,
                undefined,
                { user, ttl: Number.parseInt(appConfig.cache.ttl.productDetail), tags: [CACHE_TAGS.PRODUCT_DETAIL] },
            );

            return MCubeMapper.mapToGalliumData(data);
        } catch {
            return undefined;
        }
    }

    private getHeaders(user: UserType): Record<string, string> {
        return {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${user.accessToken}`,
            'x-version': '2',
        };
    }
}

export const mCubeRepository = new MCubeRepository(appConfig.b2r.url);
